import gql from 'graphql-tag';

const CLUB_MEMBER_DOCUMENT_UPLOAD= gql`
mutation clubMemberDocumentUpload($memberId: ID!, $documents: [PersonDocumentUploadInput!]!) { 
  clubMemberDocumentUpload(memberId: $memberId, documents: $documents) { 
      id 
      bid 
      type 
      status 
      name 
      createdAt 
      updatedAt 
      deletedAt 
      files { 
          size 
          format 
      } 
  } 
}
`;

export default CLUB_MEMBER_DOCUMENT_UPLOAD;